export class SpinnerComponent {
    public static SELECTOR: string = ".js-pcg-spinner";

    private _currentContext: JQuery = $();

    public state: boolean = false;

    public show(): void {
        this._currentContext.css("display", "block");
    }

    public hide(): void {
        this._currentContext.css("display", "none");
    }

    public init($context: JQuery): void {
        this._currentContext = $context || this._currentContext;
    }

    public static init($context: JQuery): SpinnerComponent {
        const spinnerComponent = new SpinnerComponent();
        spinnerComponent.init($context);
        return spinnerComponent;
    }
}
